import dfBrid from 'df_hybrid';

const cacheKey = 'platform';
/**
 * 地址相关key
 */
export const addressKeys = {
  /**
   * 是否是第一次写入
   */
  isFrist: cacheKey + '_frist',
  /**
   * 完整省市区
   */
  address: cacheKey + '_address',
  /**
   * 经纬度
   */
  location: cacheKey + '_location'
};

/**
 * 初始化城市信息
 * @param {*} isLocation 是否需要精准定位,默认false不需要
 * @param {*} isEN 是否英文版
 * @param {requestCallback} cb - 执行后回调.
 * @param {*} cityId 自定义城市
 */
export const initAddressDF = async function (
  isLocation = false,
  cb,
  isEN = false,
  cityId = ''
) {
  // 精准定位
  if (isLocation) {
    try {
      const _env = checkEnv();
      getLocation(_env, function (val) {
        // // 缓存中不存在写入,存在忽略
        // if (val && val.type !== 'cache') {
        //   setLocalStorageDF(location, JSON.stringify(val));
        // }
        cb && cb(val);
      });
    } catch (ex) {
      const _env = checkEnv();
      console.log('精准定位' + _env + '整体异常', ex);
      cb && cb(null);
    }
  }
  console.log('addressDetail-----------------begin');
  // 获取到详细地址
  const addressRes = await getAddress(cityId);
  const addressDetail = addressRes && addressRes.Data && addressRes.Data.data || null;
  // 如果是缓存中读取直接返回
  if (addressRes && addressRes.Data && addressRes.Data.type === 'cache') {
    return addressDetail;
  }
  if (!addressDetail) {
    console.error('未解析到城市信息');
    return;
  }
  const { city, district, region, streetList } = addressDetail;
  const street = streetList&&streetList.length > 0 ? streetList[0] : null;
  if (!street) {
    console.error('地址信息中无街道信息', addressDetail);
  }
  let cacheAddress = {
    // 省份ID
    provinceId: district.id,
    // 省份名称
    provinceName: isEN ? district.nameEn : district.nameCh,
    // 省份值
    provinceNameValue: district.nameCh,
    // 城市ID
    cityId: city.id,
    // 城市名称
    cityName: isEN ? city.nameEn : city.nameCh,
    // 城市值
    cityNameValue: city.nameEn,
    // 区域ID
    districtId: region.id,
    // 区域ID
    regionId: region.id,
    // 区域名称
    districtName: isEN ? region.nameEn : region.nameCh,
    regionName: isEN ? region.nameEn : region.nameCh,
    districtValue: region.nameCh,
    // 街道ID
    streetId: street.id,
    // 街道名称
    streetName: isEN ? street.nameEn : street.nameCh,
    streetValue: street.nameCh
  };

  setLocalStorageDF('dfAddress', JSON.stringify(cacheAddress));
  oldAddressCompatible(cacheAddress);
  console.log('addressDetail', addressDetail);
  return cacheAddress;
};

/**
 * 兼容历史逻辑
 */
function oldAddressCompatible(cacheAddress) {
  try {
    const oldAddress = {
      provinceId: cacheAddress.provinceId,
      provinceName: cacheAddress.provinceName,
      name: cacheAddress.cityName,
      cityName: cacheAddress.cityName,
      cityId: cacheAddress.cityId,
      regionId: cacheAddress.regionId,
      regionName: cacheAddress.regionName,
      streetId: cacheAddress.streetId,
      streetName: cacheAddress.streetName
    };
    // 商城
    setDFCookie('address', JSON.stringify(oldAddress));
    // 公共
    setDFCookie('city', cacheAddress.cityId, '.dongfangfuli.com');
    // 公共
    setDFCookie('dffl_mall_city', cacheAddress.cityId, '.dongfangfuli.com');
    // 百福得
    setDFCookie(
      'appCity',
      `${cacheAddress.cityName},${cacheAddress.cityId}`,
      '.dongfangfuli.com'
    );
  } catch (ex) {
    console.log('写入cookie异常', ex);
  }
}

/**
 *
 * @param {*} provinceId 省份ID
 * @param {*} provinceName 省份名称
 * @param {*} provinceNameValue 省份值
 * @param {*} cityId 城市ID
 * @param {*} cityName 城市名称
 * @param {*} cityNameValue 城市值
 * @param {*} districtId 区域ID
 * @param {*} districtName 区域名称
 * @param {*} districtValue 区域值
 * @param {*} streetId 街道ID
 * @param {*} streetName 街道名称
 * @param {*} streetValue 街道值
 * @param {*} other 自定义值
 */
export const setCatchAddress = (
  provinceId,
  provinceName,
  provinceNameValue,
  cityId,
  cityName,
  cityNameValue,
  districtId,
  districtName,
  districtValue,
  streetId,
  streetName,
  streetValue,
  id,
  other
) => {
  let cacheAddress = {
    // 省份ID
    provinceId,
    // 省份名称
    provinceName,
    // 省份值
    provinceNameValue,
    // 城市ID
    cityId,
    // 城市名称
    cityName,
    // 城市值
    cityNameValue,
    // 区域ID
    districtId,
    // 区域ID
    regionId: districtId,
    // 区域名称
    districtName,
    districtValue,
    // 街道ID
    streetId,
    // 街道名称
    streetName,
    streetValue,
    id,
    other
  };
  setLocalStorageDF('dfAddress', JSON.stringify(cacheAddress));
  if (checkEnv() === 'maxApp' || checkEnv() === 'bfdApp') {
    BFD_changeAppAddress(cityName, cityId);
  }
  oldAddressCompatible(cacheAddress);
};

/**
 *
 * @returns address object - provinceId 省份ID
 * @returns address object - provinceName 省份名称
 * @returns address object - provinceNameValue 省份值
 * @returns address object - cityId 城市ID
 * @returns address object - cityName 城市名称
 * @returns address object - cityNameValue 城市值
 * @returns address object - districtId 区域ID
 * @returns address object - districtName 区域名称
 * @returns address object - districtValue 区域值
 * @returns address object - streetId 街道ID
 * @returns address object - streetName 街道名称
 * @returns address object - streetValue 街道值
 * @returns address object - other 自定义值
 * @returns address object - null 未获取到缓存
 */
export const getCatchAddress = () => {
  // 东福统一定位地址
  const dfAddress = getLocalStorageDF('dfAddress');
  if (dfAddress) {
    // return JSON.stringify(dfAddress || {})
    return dfAddress;
  } else {
    return null;
  }
};

/**
 * 初始化地址
 */
 export const getAddress = async function (cityId = '') {
  // 后期对外唯一标准
  const urlCity = getUrlParams('city');
  // 平台cookie场景
  const addressCity = getDFCookie('address');
  // 东福统一定位地址
  const dfAddress = getLocalStorageDF('dfAddress');
  // 百福得cookie场景
  const appCity = getDFCookie('appCity');
  // 返回地址
  let return_address = null;
  // 自定义地址
  if (cityId) {
    return_address = await getAddressInfo('city', cityId);
  } else if (urlCity && !checkFrist(urlCity)) {
    // url中是否携带地址,检查这个地址是否是已经记录缓存过,如果缓存过了直接略过
    console.log('城市统一定位 ---- url city');
    setLocalStorageDF(addressKeys.isFrist, urlCity);
    // 直接解析城市获取完整城市信息
    return_address = await getAddressInfo('city', urlCity);
    console.log('城市统一定位 ---- 读取URL城市解析', urlCity, return_address);
  } else if (dfAddress) {
    // 统一定位城市
    const returnObj = {
      data: JSON.parse(dfAddress),
      type: 'cache'
    };
    const isBfd = getUrlParams('union');
    // 兼容历史逻辑
    if (checkEnv() === 'maxApp' || checkEnv() === 'bfdApp' || isBfd) {
      const citys = appCity ? appCity.split(',') : [];
      if (citys.length >= 2) {
        let _cityId;
        const citys1 = +citys[0];
        const citys2 = +citys[1];
        if (!Number.isNaN(citys1)) {
          _cityId = citys1;
        } else if (!Number.isNaN(citys2)) {
          _cityId = citys2;
        }
        if (returnObj.cityId === _cityId) {
          return_address = { Data: returnObj };
        } else {
          // 直接解析城市获取完整城市信息
          return_address = await getAddressInfo('city', _cityId);
        }
      }
    } else {
      const _address = JSON.parse(addressCity);
      if (returnObj.cityId === _address.cityId) {
        return_address = { Data: returnObj };
      } else {
        // 直接解析城市获取完整城市信息
        return_address = await getAddressInfo('city', _address.cityId);
      }
    }
    // return_address = { Data: returnObj }
    console.log('城市统一定位 ---- 读取统一定位直接返回', return_address);
  } else if (appCity) {
    // 百福得cookie场景
    const citys = appCity.split(',');
    if (citys.length >= 2) {
      let _cityId;
      const citys1 = +citys[0];
      const citys2 = +citys[1];
      if (!Number.isNaN(citys1)) {
        _cityId = citys1;
      } else if (!Number.isNaN(citys2)) {
        _cityId = citys2;
      }
      // 直接解析城市获取完整城市信息
      return_address = await getAddressInfo('city', _cityId);
    } else {
      // 无外部影响直接走ip获取城市
      return_address = await getAddressInfo('ip');
    }
  } else if (addressCity) {
    // 兼容历史cookie存放city场景
    // 因为address cookie有多方写入，写入标准不统一造成值格式不一致，需做多层逻辑判断
    // 平台cookie场景
    const _address = JSON.parse(addressCity);
    if (_address.provinceId && _address.cityId && _address.regionId) {
      // 不直接采用cookie里面数据，用city调用接口从新查询一次，防止垃圾数据
      return_address = await getAddressInfo('city', _address.cityId);
    } else if (_address.id) {
      // 体检业务场景
      return_address = await getAddressInfo('city', _address.id);
      if (!return_address) {
        // 如果是垃圾数据，造成未解析到城市，通过IP从新获取
        return_address = await getAddressInfo('ip');
      }
    } else {
      // 兜底
      return_address = await getAddressInfo('ip');
    }
  } else {
    // 无外部影响直接走ip获取城市
    return_address = await getAddressInfo('ip');
  }
  if (
    return_address &&
    return_address.Data &&
    return_address.Data.code &&
    return_address.Data.code != 200 &&
    !return_address.Data.data
  ) {
    return_address = await getAddressInfo('city', 145);
  }
  return return_address;
};

/**
 * 回调方法.
 *
 * @callback requestCallback
 * @param {number} responseCode 200 表示执行成功
 * @param {string} responseMessage 信息
 * @param {object} data 返回执行成功结果对象
 */

/**
 * 获取定位
 * @param {Object[]} type - 是否指定定位方式,不传递默认浏览器定位.
 * @param {string} type - wx - 微信定位.
 * @param {string} type - bfdApp - 百福得app定位.
 * @param {string} type - maxApp - maxApp定位.
 * @param {string} type - browser - 浏览器定位.
 * @param {requestCallback} cb - 执行后回调.
 */
export const getLocation = async (
  type = 'wx' | 'qywx' | 'bfdApp' | 'maxApp' | 'browser' | '',
  cb
) => {
  // const cacheLocation = getLocalStorageDF(addressKeys.location);
  // if (cacheLocation) {
  //   try {
  //     const _val = JSON.parse(cacheLocation);
  //     if (_val && _val.code === 200) {
  //       return cb && cb({ type: 'cache', ..._val });
  //     } else {
  //       // 失败的定位缓存或者垃圾缓存 全部清空
  //       setLocalStorageDF(addressKeys.location, '');
  //     }
  //   } catch (ex) {
  //     console.error('getLocation', ex);
  //     // 失败的定位缓存或者垃圾缓存 全部清空
  //     setLocalStorageDF(addressKeys.location, '');
  //   }
  // }
  let rData = { type: type };
  switch (type) {
    case 'wx':
    case 'qywx':
      getDFLocationByWX().then((value) => {
        rData = { ...rData, ...value };
        console.log(type + '微信定位结果', rData);
        cb && cb(rData);
      });
      break;
    case 'bfdApp':
    case 'maxApp':
      getLocationByApp().then((value) => {
        rData = { ...rData, ...value };
        console.log(type + 'APP定位结果', rData);
        cb && cb(rData);
      });
      break;
    case 'browser':
      getLocationByBrowser().then((value) => {
        rData = { ...rData, ...value };
        console.log('浏览器定位结果', rData);
        cb && cb(rData);
      });
      break;
    default:
      break;
  }
};

/**
 * 获取完整城市信息
 * @param {string} type - ip 代表后台根据用户发送IP定位城市
 * @param {string} type - city 代表后台根据东福城市ID查询城市
 * @param {number} cityId 枚举为city时必填
 * @param {object} location 枚举为location时必填
 * @returns Promise
 */
export async function getAddressInfo(type = 'ip' | 'city' | 'location', cityId = '', location = null) {
  try {
    let params = {};
    switch (type) {
      case 'city':
        params = { cityId: cityId };
        break;
      case 'ip':
        // ip定位不需要
        params = {};
        break;
      case 'location':
        // 经纬度定位
        params = {
          longitude: location.lng,
          latitude: location.lat,
        }
        break
      default:
        break;
    }
    const api = new ApiHttpHelper();
    const secretKey = 'XCwAjoB4';
    const cardCountParams = getParamsEncryption(params, '100060', secretKey);
    return api.Post('/gw/app/position/external/getAddressInfo', cardCountParams);
  } catch (error) {
    let params = { cityId: 145 };
    const api = new ApiHttpHelper();
    const secretKey = 'XCwAjoB4';
    const cardCountParams = getParamsEncryption(params, '100060', secretKey);
    return api.Post('/gw/app/position/external/getAddressInfo', cardCountParams);
  }
}

/**
 * 通过经纬度获取完整四级地址信息
 * @param {string} type - location 代表当前定位经纬度
 * @param {object} location 枚举为location时必填
 * @returns Promise
 */
export async function getAddressDetail(type = 'location', location = null) {
  try {
    let params = {};
    switch (type) {
      case 'location':
        // 经纬度定位
        params = {
          longitude: location.lng,
          latitude: location.lat,
        }
        break
      default:
        break;
    }
    const api = new ApiHttpHelper();
    const secretKey = 'XCwAjoB4';
    const cardCountParams = getParamsEncryption(params, '100060', secretKey);
    return api.Post('/gw/app/position/external/getAddressReParseInfo', cardCountParams);
  } catch (error) {
    let params = { cityId: 145 };
    const api = new ApiHttpHelper();
    const secretKey = 'XCwAjoB4';
    const cardCountParams = getParamsEncryption(params, '100060', secretKey);
    return api.Post('/gw/app/position/external/getAddressReParseInfo', cardCountParams);
  }
}

/**
 * 获取微信定位
 */
const getDFLocationByWX = () =>
  new Promise(function (resolve, reject) {
    getWXAuth().then((e) => {
      if (!e.Data) {
        console.error('获取微信鉴权失败');
        resolve({ code: -1 });
        return;
      }
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: e.Data.appId, // 必填，公众号的唯一标识
        timestamp: e.Data.timestamp, // 必填，生成签名的时间戳
        nonceStr: e.Data.nonceStr, // 必填，生成签名的随机串
        signature: e.Data.signature, // 必填，签名
        jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        wx.getLocation({
          type: 'wgs84',
          success(res) {
            const location = {
              lat: res.latitude,
              lng: res.longitude
            };
            resolve({ code: 0, location });
            console.log('success', res);
          },
          fail(res) {
            resolve({ code: -1 });
            console.log('微信授权失败', res);
          }
        });
      });
    });
  });

/**
 * 获取app经纬度
 */
const getLocationByApp = () =>
  new Promise(function (resolve, reject) {
    BFD_appGetGpsLoc((data) => {
      if (data) {
        console.log('定位成功!', data);
        resolve({ code: 0, location:data });
      } else {
        resolve({ code: -1 });
        console.log('获取app定位失败');
      }
    });
  });

/**
 * 获取浏览器定位
 * @returns {Promise} Promise
 */
const getLocationByBrowser = () =>
  new Promise(function (resolve, reject) {
    if (!navigator.geolocation) {
      console.log('当前浏览器不支持定位!1');
      resolve({ code: -1 });
    }
    window.navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        resolve({ code: 0, location });
        console.log('定位成功!', location);
        return { code: 0, location };
      },
      (err) => {
        console.log('当前浏览器不支持定位!2', err);
        resolve({ code: -1 });
      },
      {
        timeout: 5000 // 3 秒超时
      }
    );
  });

/**
 * 微信授权
 */
const getWXAuth = () => {
  // 1 微信 ; 2 企业微信
  const type = navigator.userAgent.match(/wxwork/i) ? 2 : 1;
  const api = new ApiHttpHelper();
  return api.Post('/permission_valid_config/signature', {
    caller: type,
    url: window.location.href.split('#')[0]
  });
};

function checkFrist(city) {
  // 如果城市在缓存内存在说明已经记录过,直接忽略
  const val = getLocalStorageDF(addressKeys.isFrist);
  return val === city;
}

/**
 * 根据对象解析成url参数
 * @param params 参数对象
 */
function getUrlParamsByObject(params) {
  if (typeof params === 'undefined' || params === null) {
    return '';
  } else if (typeof params === 'string') {
    return params;
  } else {
    let keys = Object.keys(params);
    let urlParams = '';
    keys.map((key) => {
      urlParams += `&${key}=${params[key]}`;
    });
    return urlParams;
  }
}
/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
function getUrlParams(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return '';
}

/**
 * 获取cookie值
 * @param {*} cookieName - key
 * @returns string
 */
function getDFCookie(cookieName) {
  var cookieString = document.cookie;
  var start = cookieString.indexOf(cookieName + '=');
  // 加上等号的原因是避免在某些 Cookie 的值里有
  // 与 cookieName 一样的字符串。
  if (start == -1)
    // 找不到
    return null;
  start += cookieName.length + 1;
  var end = cookieString.indexOf(';', start);
  if (end == -1) return unescape(cookieString.substring(start));
  return unescape(cookieString.substring(start, end));
}

/**
 * 写入cookie
 * @param {*} name 写入key
 * @param {*} value 写入value
 * @param {*} domain 指定域名 默认当前域名
 * @param {*} path 路径 默认/
 */
function setDFCookie(name, value, domain, path) {
  var cookie = name + '=' + encodeURIComponent(value); //设置Cookie的名称和Cookie的值，Cookie名称为必填项。
  if (!path) {
    cookie += ';path=/';
  } //设置Cookie的路径，默认为 /
  if (domain) {
    cookie += ';domain=' + domain;
  } //设置Cookie的存储域，默认为当前js执行的网页的域
  document.cookie = cookie;
}

/**
 * 写入缓存
 * @param key 键
 * @param value 值
 */
function setLocalStorageDF(key, value) {
  const _win = window;
  _win.localStorage.setItem(key, value);
}

/**
 * 读取缓存
 * @param key 键
 */
function getLocalStorageDF(key) {
  const _win = window;
  return _win.localStorage.getItem(key);
}

/**
 * 清除缓存
 * @param key 键
 * @param value 值
 */
export function removeLocalStorageDF(key) {
  const _win = window;
  _win.localStorage.removeItem(key);
}

/**
 * 浏览器关闭,释放
 */
window.onbeforeunload = function () {
  var n = window.event.screenX - window.screenLeft;
  var b = n > document.documentElement.scrollWidth - 20;
  const _win = window;
  if ((b && window.event.clientY < 0) || window.event.altKey) {
    // 关闭浏览器清空缓存
    _win.localStorage.clear();
    // 清除cookie
    document.cookie
      .split(';')
      .forEach(
        (cookie) =>
        (document.cookie = cookie
          .replace(/^ +/, '')
          .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`))
      );
  }
};

/* eslint-disable */
function encodeUTF8(s) {
  let i
  const r = []
  let c
  let x
  for (i = 0; i < s.length; i++)
    if ((c = s.charCodeAt(i)) < 0x80) r.push(c)
    else if (c < 0x800) r.push(0xc0 + ((c >> 6) & 0x1f), 0x80 + (c & 0x3f))
    else {
      if ((x = c ^ 0xd800) >> 10 == 0)
        // 对四字节UTF-16转换为Unicode
        (c = (x << 10) + (s.charCodeAt(++i) ^ 0xdc00) + 0x10000),
          r.push(0xf0 + ((c >> 18) & 0x7), 0x80 + ((c >> 12) & 0x3f))
      else r.push(0xe0 + ((c >> 12) & 0xf))
      r.push(0x80 + ((c >> 6) & 0x3f), 0x80 + (c & 0x3f))
    }
  return r
}

/**
 * 字符串加密成 hex 字符串
 * @param {*} s
 * @returns
 */
function sha1(s) {
  const data = new Uint8Array(encodeUTF8(s))
  var i
  let j
  let t
  const l = (((data.length + 8) >>> 6) << 4) + 16
  var s = new Uint8Array(l << 2)
  s.set(new Uint8Array(data.buffer)), (s = new Uint32Array(s.buffer))
  for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2)
  s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8)
  s[l - 1] = data.length << 3
  const w = []
  const f = [
    function () {
      return (m[1] & m[2]) | (~m[1] & m[3])
    },
    function () {
      return m[1] ^ m[2] ^ m[3]
    },
    function () {
      return (m[1] & m[2]) | (m[1] & m[3]) | (m[2] & m[3])
    },
    function () {
      return m[1] ^ m[2] ^ m[3]
    },
  ]
  const rol = function (n, c) {
    return (n << c) | (n >>> (32 - c))
  }
  const k = [1518500249, 1859775393, -1894007588, -899497514]
  var m = [1732584193, -271733879, null, null, -1009589776]
    ; (m[2] = ~m[0]), (m[3] = ~m[1])
  for (i = 0; i < s.length; i += 16) {
    const o = m.slice(0)
    for (j = 0; j < 80; j++)
      (w[j] =
        j < 16
          ? s[i + j]
          : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)),
        (t =
          (rol(m[0], 5) + f[(j / 20) | 0]() + m[4] + w[j] + k[(j / 20) | 0]) |
          0),
        (m[1] = rol(m[1], 30)),
        m.pop(),
        m.unshift(t)
    for (j = 0; j < 5; j++) m[j] = (m[j] + o[j]) | 0
  }
  t = new DataView(new Uint32Array(m).buffer)
  for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2)

  const hex = Array.prototype.map
    .call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
      return (e < 16 ? '0' : '') + e.toString(16)
    })
    .join('')
  return hex.toUpperCase()
}

/**
 * 请求加密
 * @param {*} params 参数
 * @param {*} appid 应用ID
 * @param {*} secretKey 加密编码
 */
function getParamsEncryption(params, appid, secretKey) {
  const apiParams = {
    appId: appid,
    msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
    timestamp: +new Date(),
    version: '1.0.1',
    body: JSON.stringify(params),
    sign: '',
  }
  apiParams.sign = sha1(secretKey + apiParams.body + secretKey)
  return apiParams
}

class ApiHttpHelper {
  isMock = false
  constructor(isMock = false) {
    this.isMock = isMock
  }
  Get(url, params, headers, async = false) {
    return new Promise((resolve, reject) => {
      let item = {
        Status: -1,
      }

      if (process.env.apiType === 'mock' || this.isMock) {
        const time = parseInt((Math.random() * 4000).toString())
        setTimeout(() => {
          resolve(item)
        }, time)
        return
      }
      try {
        let xhr = new XMLHttpRequest()
        xhr.open(
          'get',
          this.urlHandler(url) + getUrlParamsByObject(params),
          async
        )
        this.setHeader(headers, xhr)
        xhr.send()
        item.Status = xhr.status
        if (xhr.status === 200) {
          item.Data = this.strToJson(xhr.responseText)
          resolve(item)
        } else {
          reject(item)
        }
      } catch (e) {
        item.Message = e.message
        reject(item)
      }
    })
  }
  Post(url, params, applicationType = false, headers, async = false) {
    return new Promise((resolve, reject) => {
      let item = {
        Status: -1,
      }
      try {
        let xhr = new XMLHttpRequest()
        // 携带cookie
        xhr.withCredentials = true

        xhr.open('POST', this.urlHandler(url), async)
        xhr = this.setHeader(headers, xhr, applicationType)
        // console.log(this.bodyHandler(params, applicationType),this.urlHandler(url))
        xhr.send(this.bodyHandler(params, applicationType))
        item.Status = xhr.status

        if (xhr.status === 200) {
          let obj = this.strToJson(xhr.responseText)
          if (typeof obj === 'object') {
            item.Data = obj.body ? obj.body : obj
            item.Status = obj.respCode ? obj.respCode : obj.code
            item.Message = obj.respMsg ? obj.respMsg : obj.msg
          } else {
            item.Data = obj
          }
          resolve(item)
        } else {
          reject(item)
        }
      } catch (e) {
        item.Message = e.message
        reject(item)
      }
    })
  }
  strToJson(str) {
    try {
      return JSON.parse(str)
    } catch {
      return str
    }
  }

  bodyHandler = (params, applicationType = true) => {
    let unionParams = {}
    if (typeof params === 'undefined' || params === null) {
      if (applicationType) {
        return `platform=1`
      } else {
        unionParams.platform = 1
        return JSON.stringify(unionParams)
      }
    } else if (typeof params === 'string') {
      return params + `&platform=1`
    } else {
      unionParams = Object.assign(unionParams, params)
      unionParams.platform = 1
      if (applicationType) {
        return convertParam(unionParams)
      } else {
        return JSON.stringify(unionParams)
      }
    }
  }
  /**写入header */
  setHeader = (objs, xhr, applicationType = true) => {
    let application = ''

    if (applicationType) {
      application = 'application/x-www-form-urlencoded;'
    } else {
      application = 'application/json;'
    }
    xhr.setRequestHeader('content-Type', `${application}`)
    if (!objs) {
      return xhr
    }
    let keys = Object.keys(objs)
    keys.map(key => {
      let val = objs[key]
      xhr.setRequestHeader(key, val)
    })

    return xhr
  }
  /**请求地址处理处理 */
  urlHandler = apiUrl => {
    let basic_url = process.env.BASIC_URL
    let c = new Date()
    if (apiUrl.indexOf('?') < 0) {
      apiUrl += `?timestamp=${c.getTime()}`
    } else {
      apiUrl += `&timestamp=${c.getTime()}`
    }

    // if (apiUrl.indexOf('http') > -1 || apiUrl.indexOf('https') > -1) {
    // return apiUrl;
    // } else {
    // return basic_url + apiUrl;
    return apiUrl
    // }
  }
}

export function BFD_appGetGpsLoc(callBack) {
  try {
    console.log('appLocation调用app')
    dfBrid.DFWLocation.appGetGpsLoc(function (respData) {
      console.log('appLocation回调', respData)
      let locat = null
      if (respData.data && respData.data.longitude && respData.data.latitude) {
        locat = {
          lng: respData.data.longitude,
          lat: respData.data.latitude,
        }
      }
      callBack && callBack(locat)
      return location
    })
  } catch (e) {
    console.log('获取APP经纬度异常', e)
    callBack && callBack(null)
    return {}
  }
}

export function BFD_changeAppAddress(city, cityId) {
  console.log(`city${city},cityId${cityId}`)
  try {
      const params = {
          'city': city,     //城市名     必填
          'cityId': cityId    //城市id    必填
      }
      window.dfwAppclass.DFWCity.appSwitchCityInfo(params, function (respData) {
          var infoStr = JSON.stringify(respData)
          console.log('appRelogin', infoStr)
      })
  } catch (e) {
      console.log('更改原生地址异常', e)
      return false;
  }
  return true;
}

/**
 * 判断是否是微信环境
 */
export function checkEnv() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return 'wx'
  } else if (ua.match(/WxWork/i) == 'wxwork') {
    return 'qywx'
  } else if (
    ua.indexOf('BFD-APP') > -1 ||
    window.navigator.userAgent.indexOf('BFD-APP') > -1
  ) {
    return 'bfdApp'
  } else if (
    ua.indexOf('MAX-APP') > -1 ||
    window.navigator.userAgent.indexOf('MAX-APP') > -1
  ) {
    return 'maxApp'
  } else {
    return 'browser'
  }
}

// export default initAddressDF
